import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CheckIcon from '@material-ui/icons/Check';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { COOL_BLUE } from 'colours';
import PropTypes from 'prop-types';

export default function RadioList(props) {
  const radioStyles = makeStyles(() => ({
    checked: {},
    root: {
      color: props.color ? props.color : COOL_BLUE,
    },
  }));

  const formLabelStyles = makeStyles(() => ({
    label: {
      fontWeight: 'bold',
      fontSize: props.labelFontSize,
      lineHeight: 'normal',
    },
    root: {
      marginBottom: 10,
    },
  }));

  const selectedItem = props.items.find(i => i.checked);
  const [value, setValue] = useState(selectedItem ? selectedItem.value : '');

  const handleChange = event => {
    setValue(event.target.value);
    if (props.onRadioChange) {
      props.onRadioChange(event.target.value);
    }
  };

  const radioClasses = radioStyles();
  const formLabelClasses = formLabelStyles();

  return (
    <RadioGroup value={value} onChange={handleChange}>
      <Grid container>
        {props.items &&
          props.items.map((item, index) => (
            <Grid
              key={index}
              item
              xs={props.twoColumns ? 6 : 12}
              sm={props.twoColumns ? 6 : 12}
            >
              <FormControlLabel
                value={item.value}
                classes={formLabelClasses}
                control={
                  <Radio
                    classes={radioClasses}
                    color={props.color ? props.color : COOL_BLUE}
                    id={item.id}
                  />
                }
                label={item.label}
              />
            </Grid>
          ))}
      </Grid>
    </RadioGroup>
  );
}

RadioList.propTypes = {
  twoColumns: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      checked: PropTypes.bool.isRequired,
      values: PropTypes.string.isRequired,
      label: PropTypes.string,
    })
  ),
  onChange: PropTypes.func.isRequired,
  color: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
